"use strict";

import helpers from "./_helpers";

const Forms = () => {
    const init = () => {
        $(document).ready(function () {
            // Enable focus states
            $(document).on('click.nice_select', function(event) {
                $('.nice-select').parents('.form-group').removeClass('focused');

                if ($(event.target).closest('.nice-select').length !== 0) {
                    $(event.target).closest('.nice-select').parents('.form-group').addClass('focused');
                }
            });

            // Refreshonselect
            $('.refreshonselect').on('change', function () {
                $('#current-page').val(1);
                $('.nice-select').niceSelect('destroy');
                $('#ajax-submit').click();
                $('.nice-select').niceSelect();
            });
            // Close nice select on click
            $('.nice-select ul li').click(function () {
                setTimeout(function () {
                    $('.nice-select').removeClass("open");
                }, 10);
            });

            $("input[type='date']").parent().addClass('date-field');

            /**
             * Handle input focus to animate labels
             */
            $('input, textarea').focus(function () {
                $(this).parents('.form-group').addClass('focused');
            });
            $('input, textarea').on('blur change', function () {
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                    $(this).parents('.form-group').removeClass('focused');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            });
            $('select').change(function () {
                var inputValue = $(this).val();
                if (inputValue == "" || inputValue == "all") {
                    $(this).parents('.form-group').removeClass('filled');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            });

            $('input, textarea').on('animationstart webkitAnimationStart oAnimationStart MSAnimationStart', function(){
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                    $(this).parents('.form-group').removeClass('focused');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            })

            $('input, textarea').on('animationstart webkitAnimationStart oAnimationStart MSAnimationStart', function(){
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                    $(this).parents('.form-group').removeClass('focused');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            })

            // Enable niceselect on nice-selected dropdowns
            $('.nice-select').niceSelect();
            $('.nice-select').on('animationstart webkitAnimationStart oAnimationStart MSAnimationStart', function(){
                $(this).niceSelect('update');
            })

            // Make all 'disabled' values actually disabled - not available in form builder
            $("option:selected").each(function () {
                let $option = $(this);
                if ($option.val() === 'disabled') {
                    $option.attr('disabled', true);
                    $option.attr('selected', true);
                } else if ($option.val() !== 'all' && $option.val() !== 'empty' && $option.val() !== "") {
                    $(this).parents('.form-group').addClass('filled');
                }
            });

            // Add '*' to required fields
            $('input:required, select:required, textarea:required').each(function () {
                let $label = $(this).parents('.form-group').find('label');
                $label.addClass('required');
            });

            // Checkbox auto refresh
            $('.filter-container input[type=checkbox]').change(function() {
                $('#current-page').val(1);
                $('#ajax-submit').click();
            });
        });

        // Checkbox auto refresh
        $('.filter-container input[type=checkbox]').change(function() {
            $('#current-page').val(1);
            $('#ajax-submit').click();
        });
    };

    const onSuccess = (form) => {
        $(form).find('.alert-success').addClass('show');
        $(form).find('.alert-danger').removeClass('show');
        $([document.documentElement, document.body]).animate({
            scrollTop: $(form).offset().top - 150
        }, 200);
    };

    const onError = (form) => {
        $(form).find('.alert-danger').addClass('show');
        $(form).find('.alert-success').removeClass('show');
        $([document.documentElement, document.body]).animate({
            scrollTop: $(form).offset().top - 150
        }, 200);
    };

    return {
        init: init,
        onSuccess: onSuccess,
        onError: onError
    };
};

export default Forms;